import { Component } from 'react';
import ContactUs from '../../contact-us/contact-us';
import Modal from '../modal/modal.component';


export default class ContactUsModal extends Component<any> {
    static show(props: any) {
        Modal.createModal(ContactUsModal, props);
    }

    render() {
        return <Modal>
            <div data-modalheader>
                <h4>Contact Us</h4>
            </div>
            <div data-modalbody>
                <ContactUs embedded={true} />
            </div>
        </Modal>
    }
}
